module.exports = __webpack_public_path__ + "img/logo2.27e085d8.png";